import { useState } from "react";

const PROVIDERS = {
  godaddy: {
    name: "GoDaddy",
    dns: [
      "Log in at godaddy.com and open My Products.",
      "Find your domain and click DNS (or Manage DNS).",
      "Look for an existing record named www. If there is one, click the pencil icon to edit it. Otherwise click Add New Record.",
      "Type: CNAME · Name: www · Value: {target} · TTL: 1 hour. Click Save.",
    ],
    forward: [
      "Open the same domain and go to the Forwarding section (Domain → Forwarding).",
      "Click Add forwarding and enter https://www.{domain}.",
      "Choose Permanent (301) and Forward only, then click Save.",
    ],
  },
  hostinger: {
    name: "Hostinger",
    dns: [
      "Log in at hpanel.hostinger.com and open Domains → Domain portfolio.",
      "Click Manage next to your domain, then DNS / Nameservers in the left menu.",
      "If a CNAME record named www already exists, delete it first (Hostinger doesn't allow two).",
      "Add a new record: Type: CNAME · Name: www · Target: {target} · TTL: 3600. Click Add Record.",
    ],
    forward: [
      "In the same domain page, open Domain forwarding (sometimes called Redirects).",
      "Forward {domain} to https://www.{domain} as a Permanent (301) redirect and save.",
    ],
  },
  bigrock: {
    name: "BigRock",
    dns: [
      "Log in at bigrock.in and go to Manage Orders → List/Search Orders.",
      "Click your domain, then open DNS Management (Manage DNS).",
      "Open the CNAME Records tab and click Add CNAME Record.",
      "Host name: www · Value: {target} · TTL: 14400. Click Add Record.",
    ],
    forward: [
      "On the same domain page, open Domain Forwarding → Manage Domain Forwarding.",
      "Forward to https://www.{domain}, keep the path forwarding on, and click Save.",
    ],
  },
};

const fill = (s, target, domain) => s.replaceAll("{target}", target).replaceAll("{domain}", domain);

const Steps = ({ title, items, target, domain, testid }) => (
  <div data-testid={testid}>
    <div className="font-semibold text-sm mb-2">{title}</div>
    <ol className="space-y-2 text-sm text-slate-700">{items.map((s, i) => <li key={i} className="flex gap-3"><span className="h-6 w-6 shrink-0 rounded-full bg-indigo-600 text-white text-xs grid place-items-center">{i + 1}</span><span className="pt-0.5">{fill(s, target, domain)}</span></li>)}</ol>
  </div>
);

export const DomainGuide = ({ target, domain = "yourbrand.com" }) => {
  const [p, setP] = useState("godaddy");
  const g = PROVIDERS[p];
  return (
    <div className="space-y-6" data-testid="domain-guide">
      <div className="flex gap-2 flex-wrap">{Object.entries(PROVIDERS).map(([k, v]) => <button key={k} onClick={() => setP(k)} className={`px-4 py-1.5 rounded-full text-sm border transition-colors ${p === k ? "bg-indigo-600 text-white border-indigo-600" : "bg-white hover:bg-slate-50"}`} data-testid={`domain-guide-tab-${k}`}>{v.name}</button>)}</div>
      <Steps title={`1. Point www.${domain} to your store`} items={g.dns} target={target} domain={domain} testid="domain-guide-dns-steps" />
      <Steps title={`2. Send ${domain} (without www) to www.${domain}`} items={g.forward} target={target} domain={domain} testid="domain-guide-forward-steps" />
      <div className="text-sm text-slate-600 space-y-1.5 border-t pt-4">
        <div className="font-semibold text-slate-800">3. Check the connection</div>
        <p>Go back to Website → Domains in Two Thread and click Check connection. Changes usually show within 15–30 minutes and can take up to 24 hours. The secure https certificate is added automatically.</p>
        <p className="text-xs text-slate-500">Moved your domain's nameservers to Cloudflare or another DNS provider? Add the same CNAME record there instead (in Cloudflare, set it to DNS only). Stuck? Ask your provider's support to "add a CNAME record for www pointing to {target} and forward the root domain to https://www.{domain}".</p>
      </div>
    </div>
  );
};
